export const webcamSuffix = "_webcam";

export const expertWebcamName = `expert${webcamSuffix}`;
export const pedagogyWebcamName = `pedagogy${webcamSuffix}`;
export const studentWebcamName = `student${webcamSuffix}`;

export const isWebcamName = (name: string): boolean => {
  return name.endsWith(webcamSuffix);
}